const STEPS = [
  {
    n: "01",
    title: "Complimentary discovery call",
    time: "30 minutes",
    body:
      "We walk your current website with a board member or property manager, log the visible gaps, and confirm which statutes apply to your community structure.",
  },
  {
    n: "02",
    title: "Statutory compliance audit",
    time: "5-7 business days",
    body:
      "Line-by-line review against FS 720.303, 718.111, 719.104, HOPA and WCAG 2.2. You receive a written report, risk score and prioritized remediation plan.",
  },
  {
    n: "03",
    title: "Remediation and rebuild",
    time: "2-6 weeks",
    body:
      "We remediate PDFs, restructure the records vault, rebuild owner login, and stage everything for board approval before we go live.",
  },
  {
    n: "04",
    title: "Ongoing compliance monitoring",
    time: "Monthly",
    body:
      "We monitor statute changes, ADA guidance, and expiring disclosures while filing quarterly compliance certificates for your board minutes.",
  },
];

export default function Process() {
  return (
    <section id="process" className="py-24 md:py-32 bg-foreground-950 text-background-50 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-25"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=abstract%20blurred%20south%20florida%20palm%20frond%20silhouettes%20at%20dusk%20with%20warm%20amber%20and%20teal%20gradient%20sky%2C%20soft%20cinematic%20editorial%20background%20photography%2C%20minimal%20artistic%20composition%20with%20negative%20space%2C%20moody%20tropical%20evening%20atmosphere&width=2000&height=1400&seq=process-bg-04&orientation=landscape')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-foreground-950/85" />

      <div className="relative z-10 max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-16">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-accent-300 font-semibold">
            <i className="ri-route-line" />
            The Integrity method
          </span>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl font-semibold text-background-50 leading-[1.05]">
            A calm, documented path from unknown risk to signed conformance.
          </h2>
          <p className="mt-6 text-background-100 text-lg leading-relaxed">
            Boards change every year. Our process gives your community a compliance system that survives
            turnover, rather than a temporary project that lapses during the next election cycle.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((s, i) => (
            <div
              key={s.n}
              className="relative rounded-lg bg-background-50/5 border border-background-50/15 p-7 backdrop-blur-sm hover:bg-background-50/10 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="font-heading text-4xl font-semibold text-accent-300">{s.n}</span>
                {i < STEPS.length - 1 && (
                  <i className="ri-arrow-right-line text-background-50/40 text-xl hidden lg:block" />
                )}
              </div>
              <h3 className="mt-4 font-heading text-xl font-semibold text-background-50">
                {s.title}
              </h3>
              <div className="mt-1 inline-flex items-center gap-1.5 text-xs text-accent-200">
                <i className="ri-time-line" />
                {s.time}
              </div>
              <p
                className="mt-4 text-background-100 text-sm leading-relaxed"
                dangerouslySetInnerHTML={{ __html: s.body }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}